// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

/* .MuiAutocomplete-root {
  width: 80%;
} */

.MuiAutocomplete-inputRoot {
  padding-right: 5px !important;
}

.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input{
  padding: 5px 30px 5px 10px !important;
}


/* App.css */
 
.content {
  text-align: center;
  margin-top: 20px;
}

.toggle-button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
}

.toggle-button:hover {
  background-color: #45a049;
}

/* Right side panel styles */
.right-panel {
  position: fixed;
  right: -300px; /* Initially off-screen */
  top: 0;
  height: 100%;
  width: 300px;
  background-color: #fff;
  color: #333;
  transition: right 0.3s ease-in-out;
  /* padding: 20px;  */
  z-index: 100;
  overflow-y: auto;
  box-shadow: 2px 2px 10px lightgray;
}

.right-panel.open {
  right: 0; /* Slide in when the panel is open */
  /* position: absolute; */
}

.right-panel h2 {
  margin-top: 0;
}

.right-panel button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #f44336;
  color: white;
  border: none;
  cursor: pointer;
}

.right-panel button:hover {
  background-color: #e53935;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;;AAGA,YAAY;;AAEZ;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,aAAa,EAAE,yBAAyB;EACxC,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,QAAQ,EAAE,oCAAoC;EAC9C,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".App {\n  text-align: center;\n}\n\n/* .MuiAutocomplete-root {\n  width: 80%;\n} */\n\n.MuiAutocomplete-inputRoot {\n  padding-right: 5px !important;\n}\n\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input{\n  padding: 5px 30px 5px 10px !important;\n}\n\n\n/* App.css */\n \n.content {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.toggle-button {\n  padding: 10px 20px;\n  font-size: 16px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n.toggle-button:hover {\n  background-color: #45a049;\n}\n\n/* Right side panel styles */\n.right-panel {\n  position: fixed;\n  right: -300px; /* Initially off-screen */\n  top: 0;\n  height: 100%;\n  width: 300px;\n  background-color: #fff;\n  color: #333;\n  transition: right 0.3s ease-in-out;\n  /* padding: 20px;  */\n  z-index: 100;\n  overflow-y: auto;\n  box-shadow: 2px 2px 10px lightgray;\n}\n\n.right-panel.open {\n  right: 0; /* Slide in when the panel is open */\n  /* position: absolute; */\n}\n\n.right-panel h2 {\n  margin-top: 0;\n}\n\n.right-panel button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  background-color: #f44336;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n.right-panel button:hover {\n  background-color: #e53935;\n}\n\ntable {\n  font-family: arial, sans-serif;\n  border-collapse: collapse;\n  width: 100%;\n}\n\ntd, th {\n  border: 1px solid #dddddd;\n  text-align: center;\n  padding: 8px;\n}\n\ntr:nth-child(even) {\n  background-color: #dddddd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
